import { LoadablePaint } from '@confluence/loadable';

export const RecommendedPageBannerNoContent = LoadablePaint({
	loader: () =>
		import(
			/* webpackChunkName: "loadable-RecommendedPageBannerNoContent" */ '../src/RecommendedPageBannerNoContent.tsx'
		).then((module) => module.RecommendedPageBannerNoContent),
});

export type {
	BannerTemplateKey,
	RecommendedPageBannerNoContentProps,
} from '../src/RecommendedPageBannerNoContent.tsx';
